import { CANADIAN_COUNTRY } from '../../../constants';

function isEmpty(val) {
  return val == '' || val == null;
}

function validateBenefName(beneficiaryName) {
  if (!isEmpty(beneficiaryName)) {
    const lengthValid = beneficiaryName.replace(/\s/g, '').length >= 3;  //WMCE-40324,wmce-39738
    // let benefNameArray = (beneficiaryName.split(" "));
    // let benefNameValid = true;
    // const regex = /\w*[a-zA-Z]\w*/;
    // for (let i in benefNameArray) {
    //   benefNameValid = benefNameValid && (benefNameArray[i] != "" ?
    //    regex.test(benefNameArray[i]) : true);
    // }
    // return lengthValid && (benefNameArray.length >= 2) && benefNameValid;
    return lengthValid;
  }
  return false;
}

function isCanadian(country){
  if(country && (country.toLowerCase() === CANADIAN_COUNTRY.english || country.toLowerCase() === CANADIAN_COUNTRY.german)){
    return true;
  }
  return false;
}

function isCanadianError(message){
  const beneficiaryError = [{ errorCode: "2004", errorDesc: message, errorType: "Error", sevType: "Blocking"}];
  return beneficiaryError;
}
function replaceUmlautApostrophe(value){
  return value.replace(/’/g, "'");
} 
export { isEmpty, validateBenefName, isCanadian, isCanadianError, replaceUmlautApostrophe };
